'use client'

import { useEffect } from 'react'

import { LuRefreshCw, LuTriangleAlert } from 'react-icons/lu'

import { isDev } from '@/core/config/env'
import { cn } from '@/core/utils/common'
import { debugLog } from '@/core/utils/debug'

type ErrorProps = {
  error: Error & { digest?: string }
  retry: () => void
}

export default function RootError({ error, retry }: ErrorProps) {
  useEffect(() => {
    debugLog('render', 'RootError', {
      message: error.message,
      digest: error.digest,
      stack: error.stack,
    })
  }, [error])

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-soft px-6">
      <div className="w-full max-w-[520px] rounded-[32px] bg-background p-8 text-center over8:p-10">
        <span
          className={cn(
            'mx-auto flex size-14 items-center justify-center rounded-field',
            'bg-error/10 text-error'
          )}
        >
          <LuTriangleAlert aria-hidden="true" className="size-6" />
        </span>
        <h1 className="mt-6 text-c26 font-bold tracking-[-0.03em]">
          화면을 불러오지 못했습니다
        </h1>
        <p className="mt-3 text-c14 leading-6 text-description">
          잠시 후 다시 시도해 주세요. 같은 문제가 계속되면 관리자에게 문의해
          주세요.
        </p>
        {isDev && (
          <div className="mt-5 rounded-panel bg-surface-soft p-4 text-left">
            <p className="break-words text-c12 leading-5 text-description">
              {error.message}
            </p>
            {error.digest && (
              <p className="mt-2 text-c10 text-description">
                식별자: {error.digest}
              </p>
            )}
          </div>
        )}
        <button
          type="button"
          onClick={retry}
          className={cn(
            'mt-7 inline-flex min-h-12 items-center justify-center gap-2 rounded-field',
            'bg-point px-5 text-c14 font-bold text-inverse',
            'transition-transform duration-200 hover:-translate-y-0.5',
            'active:scale-[0.98] focus:outline-none focus-visible:scale-[0.98]'
          )}
        >
          <LuRefreshCw aria-hidden="true" className="size-4" />
          다시 시도
        </button>
      </div>
    </div>
  )
}
